export default class config {
    static ENV = 'prod';//dev or prod
    static MODE = 'history';//for mode history must server redirect as .htaccess mod rewrite
    // static API_URL = 'http://localhost:1234/';
    static API_URL = '/api/index.php/';
    static VUE_APP_I18N_LOCALE='bg';
    static VUE_APP_I18N_FALLBACK_LOCALE='en';
}